import React from 'react';
import PropTypes from 'prop-types';

import { Company } from 'components/common/Elements/Elements';
import { recordType } from 'utils/common';

const Account = ({ data }) => {
  const {
    customerId,
    companyName,
    status,
    companySize,
    country,
    poc,
    infinityPortalUuid,
    terminationStatus
  } = data;

  return (
    <Company
      nameCompany={companyName ? companyName : customerId}
      status={status}
      terminationStatus={terminationStatus}
      description={companySize}
      recordType={recordType(data)}
      country={country}
      addStatus={poc}
      customerId={customerId}
      isCheckpointTenant={infinityPortalUuid && infinityPortalUuid !== 'NA'}
    />
  );
};

Account.propTypes = {
  data: PropTypes.object
};

export default Account;
